module.exports = __webpack_public_path__ + "static/media/note-pencil.c85f3434.svg";